const { REACT_APP_ENV_MODE } = process.env;

const isMainnet = REACT_APP_ENV_MODE === 'production';

export const amdinAccount = isMainnet ? "crypto-shots" : "csjay";
export const symbolList = ['SWAP.HIVE', 'BEE', 'DOOM'];

export const symbolNft = isMainnet ? "CSHOTS" : "BASEGUN";
export const symbolPack = isMainnet ? "CSPACKS" : "CSPACKT";

export const chainID = isMainnet ? "ssc-mainnet-hive" : "ssc-testnet-hive";

console.log(`
  Launching Hive UI with configs:
  ${JSON.stringify({ isMainnet, amdinAccount, symbolList, symbolNft, chainID }, null, 2)}
`);

export const MARKET_FEE = 500; // 600 is 6%


// # UNBOXING

// TEMP @@
export const unboxerAccount = window.location.hostname === 'localhost' ? 'crypto-shots' : 'cryptoshotsdoom';

// TODO: use afer alpha!
export const isLocal = window.location.hostname !== 'hive.crypto-shots.com';
